export default (state) => {
  return Object.assign({}, state, { locked: false, loading: false });
};
